/**
 * Role Constants
 *
 * Defines well-known role codes for the Invento platform.
 * Actual role records (with permissions) are stored in the database.
 */
import { ALL_PERMISSION_VALUES, BUSINESS_PERMISSIONS, SHOP_PERMISSIONS, PRODUCT_PERMISSIONS, INVENTORY_PERMISSIONS, ORDER_PERMISSIONS, SALES_PERMISSIONS, CUSTOMER_PERMISSIONS, SUPPLIER_PERMISSIONS, PURCHASES_PERMISSIONS, MONEY_PERMISSIONS, CATEGORY_PERMISSIONS, BRAND_PERMISSIONS, USER_PERMISSIONS, REPORT_PERMISSIONS, SETTINGS_PERMISSIONS, SUPPORT_PERMISSIONS, } from './permissions.js';
// System-level roles (platform admin)
export const SYSTEM_ROLE = {
    SUPER_ADMIN: 'SUPER_ADMIN',
};
// Business-level roles
export const BUSINESS_ROLE = {
    OWNER: 'OWNER',
    MANAGER: 'MANAGER',
    CASHIER: 'CASHIER',
};
// Default roles seeded when a new business is created
export const DEFAULT_BUSINESS_ROLES = [
    BUSINESS_ROLE.OWNER,
    BUSINESS_ROLE.MANAGER,
    BUSINESS_ROLE.CASHIER,
];
// Default role → permission mappings
export const DEFAULT_ROLE_PERMISSIONS = {
    [SYSTEM_ROLE.SUPER_ADMIN]: ALL_PERMISSION_VALUES,
    [BUSINESS_ROLE.OWNER]: ALL_PERMISSION_VALUES,
    [BUSINESS_ROLE.MANAGER]: [
        BUSINESS_PERMISSIONS.READ,
        ...Object.values(SHOP_PERMISSIONS),
        ...Object.values(PRODUCT_PERMISSIONS),
        ...Object.values(INVENTORY_PERMISSIONS),
        ...Object.values(ORDER_PERMISSIONS),
        ...Object.values(SALES_PERMISSIONS),
        ...Object.values(CUSTOMER_PERMISSIONS),
        ...Object.values(SUPPLIER_PERMISSIONS),
        ...Object.values(PURCHASES_PERMISSIONS),
        ...Object.values(MONEY_PERMISSIONS),
        ...Object.values(CATEGORY_PERMISSIONS),
        ...Object.values(BRAND_PERMISSIONS),
        USER_PERMISSIONS.CREATE,
        USER_PERMISSIONS.READ,
        USER_PERMISSIONS.UPDATE,
        USER_PERMISSIONS.INVITE,
        REPORT_PERMISSIONS.READ,
        SETTINGS_PERMISSIONS.READ,
        ...Object.values(SUPPORT_PERMISSIONS),
    ],
    [BUSINESS_ROLE.CASHIER]: [
        PRODUCT_PERMISSIONS.READ,
        ORDER_PERMISSIONS.CREATE,
        ORDER_PERMISSIONS.READ,
        SALES_PERMISSIONS.READ,
        SALES_PERMISSIONS.POS_CREATE,
        SALES_PERMISSIONS.POS_SHIFT_CLOSE,
        CUSTOMER_PERMISSIONS.READ,
        CATEGORY_PERMISSIONS.READ,
        BRAND_PERMISSIONS.READ,
    ],
};
export const isSystemRole = (code) => {
    return Object.values(SYSTEM_ROLE).includes(code);
};
export const isBusinessRole = (code) => {
    return Object.values(BUSINESS_ROLE).includes(code);
};
export const isValidRoleCode = (code) => {
    return isSystemRole(code) || isBusinessRole(code);
};
//# sourceMappingURL=roles.js.map